import * as React from 'react';

export default (handler: () => void, autoHandle: boolean = true) => {
	const node = React.useRef(null);

	const handleClick = (e: MouseEvent) => {
		const $node = node.current as HTMLElement|null;

		if ($node !== null && !$node.contains(e.target as HTMLElement)) {
			handler();
		}
	};

	const enableHandler = () => document.addEventListener('mousedown', handleClick);
	const disableHandler = () => document.removeEventListener('mousedown', handleClick);

	React.useEffect(() => {
		if (autoHandle) {
			enableHandler();
		}

		return disableHandler;
	}, []);

	return {
		node,
		enableHandler,
		disableHandler
	};
}
